import { render, staticRenderFns } from "./ExIcon.vue?vue&type=template&id=4050e352&scoped=true&"
import script from "./ExIcon.vue?vue&type=script&lang=js&"
export * from "./ExIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4050e352",
  null
  
)

export default component.exports